function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
//Limitless imports
import { withi18n } from "../../../../../customer/components/hocs/i18n";
import { useClientActions } from "../../../../../expert/hooks/client-action/ClientActionHook";
import ExpertDialogueWrapper from "../expert-dialogue-wrapper/ExpertDialogueWrapper";
import ExpertDialogueBody from "../expert-dialogue-body/ExpertDialogueBody";
import ExpertTimePosted from "../expert-time-posted/ExpertTimePosted";
import { CLAIM_TIMEOUT } from "@limitless/portal";
const useStyles = makeStyles({
  button: {
    cursor: "pointer",
    textDecoration: "underline"
  }
});
const ClientActionDialogue = ({
  t,
  message,
  dialogue,
  ...rest
}) => {
  var _message$inbox;
  const {
    body,
    created
  } = dialogue;
  const {
    clientAction,
    loadClientAction
  } = useClientActions(message, t);
  const classes = useStyles();
  const {
    loading,
    hasClicked
  } = clientAction;
  const isClaimedByUser = rest.profile.userName === ((_message$inbox = message.inbox) === null || _message$inbox === void 0 ? void 0 : _message$inbox.userId);
  let hasClaimTimedOut = false;
  if (message.conversationState.state === CLAIM_TIMEOUT) {
    hasClaimTimedOut = true;
  }
  if (hasClaimTimedOut || !isClaimedByUser || loading || hasClicked) {
    return /*#__PURE__*/React.createElement("div", null);
  }
  return /*#__PURE__*/React.createElement(ExpertDialogueWrapper, _extends({
    shouldAnimate: false,
    dialogue: dialogue,
    message: message
  }, rest), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: `${classes.responseListItem} ${classes.secondaryBackground} ${hasClicked ? "" : classes.button}`,
    onClick: hasClicked ? null : loadClientAction
  }, /*#__PURE__*/React.createElement(ExpertDialogueBody, {
    body: body
  })), /*#__PURE__*/React.createElement(ExpertTimePosted, {
    dialogue: dialogue,
    time: created
  })));
};
export default withi18n(ClientActionDialogue);
ClientActionDialogue.propTypes = {
  message: PropTypes.object.isRequired,
  dialogue: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired
};